import { Navigate } from "react-router-dom";
import { decideRootRedirect } from "./smartRootIndexLogic";

// Picks the right destination when the browser lands on "/", which happens
// when MetaMask Mobile's in-app browser "refresh" reloads from the session
// root rather than the current URL. Three cases:
//   - Fresh metamaskReturnUrl from an in-flight recharge -> go there
//   - Recent lastUserPath (any deep user page) -> go there
//   - No history -> fall back to /auth/login (GuestGuard will then send
//     authenticated users to /user/dashboard).
const SmartRootIndex = () => {
  let target = "/auth/login";
  try {
    target = decideRootRedirect(
      (key) => {
        try {
          return localStorage.getItem(key);
        } catch {
          return null;
        }
      },
      (key) => {
        try {
          localStorage.removeItem(key);
        } catch {
          // ignore
        }
      }
    );
  } catch {
    // ignore - fall back to default
  }
  return <Navigate to={target} replace />;
};

export default SmartRootIndex;
